<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">忘记密码</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="password">
                <span>新密码</span>
                <input type="tel" placeholder="请输入密码" maxlength="11">
                <img v-if="!isSee" src="../../assets/images/show.png">
                <img v-if="isSee" src="../../assets/images/hide.png">
            </div>
            <div class="repassword">
                <span>确认密码</span>
                <input type="tel" maxlength="6" placeholder="请再次输入密码">
                <img v-if="!isSee" src="../../assets/images/show.png">
                <img v-if="isSee" src="../../assets/images/hide.png">
            </div>
            <span class="statement">如需帮助，请拨打客服热线：021-80158000</span>
            <button class="achieve">完成</button>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return { 
        isSee:false,     
    };
  },
  computed: {},
  components: {},
  methods: {     
  }           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  font-size: 0.42rem;
  /* background-color: rgba(0, 0, 0, 0.1); */
  height: 100%;
  width: 100%;
}
.password{
    width: 96%;
    height: 1.47rem;
    line-height: 1.47rem;
    margin-left: 0.2rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.05);
    position: relative;
}
.repassword{
    width: 96%;
    height: 1.47rem;
    line-height: 1.47rem;
    margin-left: 0.2rem;
    position: relative;
}
.password input{
    width: 4rem;
    font-size: 0.42rem;
    border: none;
    margin-left: 1.55rem;
}
.repassword input{
    width: 4rem;
    font-size: 0.42rem;
    border: none;
    margin-left: 1.1rem;
}
.password span,
.repassword span{
    margin-left: 0.26rem;
}
img{
    width: 0.53rem;
    height: 0.53rem;
    position: absolute;
    top: 0.45rem;
    right: 0.47rem;
}
.statement{
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.5);
    margin-left: 0.53rem;
}
.achieve{
    width: 6.71rem;
    height: 1.05rem;
    line-height: 0.61rem;
    border: none;
    border-radius: 0.16rem;
    background-color: rgba(41, 158, 173, 1);
    color: rgba(255, 255, 255, 1);
    letter-spacing: 0.2rem;
    font-size: 0.47rem;
    text-align: center;
    position: relative;
    top: 0.84rem;
    left: 1.58rem;
}
</style>



// WEBPACK FOOTER //
// src/components/login/changePassword.vue